// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--KeZwYQ9yUBHqp3qp"};